import { render, staticRenderFns } from "./UpdatePhoneBox.vue?vue&type=template&id=677fa2e2&scoped=true"
import script from "./UpdatePhoneBox.vue?vue&type=script&lang=js"
export * from "./UpdatePhoneBox.vue?vue&type=script&lang=js"
import style0 from "./UpdatePhoneBox.vue?vue&type=style&index=0&id=677fa2e2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "677fa2e2",
  null
  
)

export default component.exports